<template>
  <section class="modules-wrap">
    <!-- table start -->
    <div class="table">
    

<el-collapse accordion v-if="is_print_member_no==1">

      <el-collapse-item v-for="(item, index) of tableData" :key="item[id]" class="table-row">
    <template slot="title">
      <!-- 头部 start -->
        <div class="table-row-header">
          <div class="header-content">
            <div class="content-left">
              {{ `${index + 1}# ${item.product_title}` }}
            </div>
            <div>
              <span class="label">总件数：</span
              >{{ item.product_number }}&nbsp;&nbsp;/&nbsp;
              <span class="label">等级：</span
              >{{ item.product_grade }}&nbsp;&nbsp;/&nbsp;
              <span class="label">规格：</span>{{ item.product_spec }}
            </div>
          </div>
        </div>
        <!-- 头部 end -->

        <!-- 右侧打印按钮 start -->
        <div class="print-btn" @click.stop="onHandlePrint(item)">打印标签</div>
        <!-- 右侧打印按钮 end -->
    </template>
    <el-table
    :data="item.order_detail_list"
 :border="true"
      :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
    style="width: 100%">
    <el-table-column
      prop="logistics_name"
      label="城市仓名称"
       align="center"
      >
    </el-table-column>
    <el-table-column
      prop="delivery_name"
      label="自提点名称"
       align="center"
      >
    </el-table-column>
    <el-table-column
      prop="vehicle_no"
      label="车位号"
       align="center"
      >
    </el-table-column>
    <el-table-column
      prop="sort_code"
      label="坑位号"
       align="center">
    </el-table-column>
    <el-table-column
      prop="member_name"
      label="客户名称"
       align="center">
    </el-table-column>
    <el-table-column
      prop="member_mobile"
      label="客户电话"
       align="center">
    </el-table-column>
    <el-table-column
      prop="qty"
      label="订货数量"
       align="center">
    </el-table-column>
    <el-table-column
      prop="no_print_num"
      label="未打印数量"
       align="center">
    </el-table-column>
    <el-table-column
      prop="address"
      label="功能"
       align="center">


       <template slot-scope="scope">
            <el-button
              type="text"
             
              @click="handleEdit(scope.row)"
              >打印标签</el-button
            >
            
          </template>
    </el-table-column>
  </el-table>
  </el-collapse-item>


</el-collapse>
<div v-else>
<div v-for="(item, index) of tableData" :key="item[id]" class="table-row" style="display: flex;">
 <div class="table-row-header">
          <div class="header-content">
            <div class="content-left">
              {{ `${index + 1}# ${item.product_title}` }}
            </div>
            <div>
              <span class="label">总件数：</span
              >{{ item.product_number }}&nbsp;&nbsp;/&nbsp;
              <span class="label">等级：</span
              >{{ item.product_grade }}&nbsp;&nbsp;/&nbsp;
              <span class="label">规格：</span>{{ item.product_spec }}
            </div>
          </div>
        </div>
        <!-- 头部 end -->

        <!-- 右侧打印按钮 start -->
        <div class="print-btn" @click.stop="onHandlePrint(item)">打印标签</div>
        <!-- 右侧打印按钮 end -->
</div>
</div>

    </div>
    <!-- table end -->
      <el-dialog
      v-if="dataobj"
      title="提示"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="40%"
      class="dialog"
      center
    >
      <div class="contents">
        <!-- 商品信息 start -->
        <div class="goods-wrap">
          商品名称：{{dataobj.title}}
        </div>
        <div class="goods-wrap">{{dataobj.logistics_name}} {{dataobj.delivery_name}}</div>
        <div class="goods-wrap">坑位号：{{dataobj.sort_code}} 订货数量 ：{{dataobj.qty}}</div>

        <!-- 商品信息 end -->

        <el-form :model="formData" ref="refForm" :rules="formRules">
          <el-form-item label="打印数量：" prop="print_num">
            <el-input
              v-model="formData.print_num"
              placeholder="输入打印数量"
              maxlength="5"
              clearable
            >
            </el-input>
            个
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onHandleClose">取消</el-button>
        <el-button type="primary" @click="onHandleSubmit(dataobj)">确认打印</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
export default {
  name: "TableList",
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    is_print_member_no: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      id: "product_id",
       dialogVisible: false,
      dataobj: "",
      formData: {
        print_num: "", // 打印份数
      }, // 表单数据
      formRules: {
        print_num: [
          {
            required: true,
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入打印数量！"));
              }
              if (!Number(value) || validInteger(value)) {
                callback(new Error("请输入大于0的整数！"));
              }
              callback();
            },
          },
        ],
      },
    };
  },
  computed: {},
  methods: {
   /**
     * 关闭操作
     */
    onHandleClose() {
      this.dialogVisible = false;
    },
    /**
     * 确认
     */
    onHandleSubmit(data) {
      data.print_num = this.formData.print_num;
      this.handleEdit(data);
      this.onHandleClose();
    },
    handleEditdialog(data) {
      if(data.qty>1){
 this.dataobj = data;
      this.formData.print_num=data.qty;
      this.dialogVisible = true;
      }else{
        this.handleEdit(data);
      }
     
    },
    handleEdit(data) {
      this.$emit("handleEdit", data);
    },
    /**
     * 打印标签
     */
    onHandlePrint(data) {
      this.$emit("on-handle-print", data);
    },
  },
};
</script>

<style lang="scss" scoped>
$border: 1px solid $border-color;
.modules-wrap {
 .contents {
    padding: 30px;
box-sizing: border-box;
  }
  .goods-wrap {
    display: flex;

    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 30px;
    font-size: 14px;
    font-weight: 550;
    .name {
      padding-left: 5px;
      color: $danger-color;
    }
  }
  /deep/ .el-form {
    // margin-left: 120px;
    &-item__error {
      left: 110px;
    }
  }
  .el-input {
    width: 300px;
  }
  .table {
     /deep/ .el-collapse-item__wrap{
      margin-top: 10px;
    }
    &-row {
      // display: flex;
      // align-content: center;
      // justify-content: center;
      // gap: 30px;
      // margin-bottom: 30px;
      margin: 10px 0;
      &-header {
        display: flex;
        flex: 1;
        height: 56px;
        padding: 0 0px;
        line-height: 56px;
        font-size: 20px;
        border: $border;
        color: $theme-color;
        background-color: #fbfdf9;
        .header-content {
          flex: 1;
          display: flex;
          gap: 50px;
          .content-left {
            min-width: 400px;
          }
          .label {
            color: $border-color;
          }
        }
      }
      .print-btn {
        position: relative;
        top: 6px;
        height: 40px;
        padding: 0 10px;
        line-height: 40px;
        border-radius: 4px;
        display: inline-block;
        font-size: 12px;
        color: #fff;
        background-color: #13AE67;
        cursor: pointer;
      }
    }
  }
}
</style>
